module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february_opt_in_badge-4dfda240aff096f192a6796c33a4e62f.png";